<template>
  <transition name="fade">
    <div v-show="show" :class="classes" :style="outerStyles">
      <div :class="innerClasses" :style="styles"></div>
    </div>
  </transition>
</template>
<script>
import * as constants from '../../utils/constants'
const PREFIX_LOADING_BAR_CLASS = `${constants.PREFIX_CLASS}loading-bar`

export default {
  props: {
    color: {
      type: String,
      default: 'primary'
    },
    failedColor: {
      type: String,
      default: 'error'
    },
    height: {
      type: Number,
      default: 2
    }
  },
  data() {
    return {
      percent: 0,
      status: 'success',
      show: false
    }
  },
  computed: {
    classes() {
      return PREFIX_LOADING_BAR_CLASS
    },
    innerClasses() {
      return [
        `${PREFIX_LOADING_BAR_CLASS}-inner`,
        {
          [`${PREFIX_LOADING_BAR_CLASS}-inner-color-primary`]:
            this.color === 'primary' && this.status === 'success',
          [`${PREFIX_LOADING_BAR_CLASS}-inner-failed-color-error`]:
            this.failedColor === 'error' && this.status === 'error'
        }
      ]
    },
    outerStyles() {
      return {
        height: `${this.height}px`
      }
    },
    styles() {
      let style = {
        width: `${this.percent}%`,
        height: `${this.height}px`
      }
      if (this.color !== 'primary' && this.status === 'success') {
        style.backgroundColor = this.color
      }
      if (this.failedColor !== 'error' && this.status === 'error') {
        style.backgroundColor = this.failedColor
      }
      return style
    }
  }
}
</script>



// WEBPACK FOOTER //
// global-loading.vue?54ce490a